import { createSlice } from '@reduxjs/toolkit';
import { createReportApi } from '../../../rtk-apis/reports/createReport';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const createReportSlice = createSlice({
  name: 'createReportSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(createReportApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createReportApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(createReportApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = '';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default createReportSlice.reducer;
export const { clearState } = createReportSlice.actions;
